import { QueryClient, QueryClientProvider } from 'react-query';
import { createRoot } from 'react-dom/client';
import { AppRoutes } from './routing/AppRoute';
import { setupAxios } from './app/auth/core/AuthHelpers';
import axios from 'axios';
import { AuthProvider } from './app/auth';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/layout/custom.css';
import './assets/css/styles.scss';
import { TazmeenI18n } from './providers/i18n/tazmeni18n';
import { I18nProvider } from './providers/i18n/Ii18nProvider';
import MUIProvider from './providers/mui-provider/MUIProvider';
import { ConfirmProvider } from 'material-ui-confirm';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 36000000,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  },
});

setupAxios(axios);

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <TazmeenI18n>
      <I18nProvider>
        <MUIProvider>
          <ConfirmProvider
            defaultOptions={{
              confirmationButtonProps: {
                autoFocus: true,
                sx: {
                  // backgroundColor: "#4CAF50", // Green color for confirm button
                  color: '#fff',
                  // "&:hover": {
                  //   backgroundColor: "#45A049",
                  // },
                  borderRadius: '4px',
                  padding: '10px 20px',
                },
              },
              cancellationButtonProps: {
                variant: 'outlined',
                sx: {
                  // backgroundColor: "#f44336", // Red color for cancel button
                  // color: "#fff",
                  // "&:hover": {
                  //   backgroundColor: "#d32f2f",
                  // },
                  borderRadius: '4px',
                  padding: '10px 20px',
                },
              },

              dialogProps: {
                maxWidth: 'sm',
                fullWidth: true,
                sx: {
                  '& .MuiTypography-root': {
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '18px',
                  },
                  '& .MuiTypography-h6': {
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '24px',
                  },
                  '& .MuiPaper-root': {
                    maxWidth: '400px',
                    padding: '20px',
                    borderRadius: '4px',
                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)', // Subtle shadow for better design
                    backgroundColor: '#f9f9f9',
                  },
                  '& .MuiDialogActions-root': {
                    display: 'flex',
                    justifyContent: 'space-evenly', // Align buttons neatly
                  },
                  '& .MuiDialogActions-root button': {
                    minHeight: '50px',
                    minWidth: '120px',
                    fontSize: '14px',
                    '& .MuiButton-containedPrimary': {},
                  },
                  '& .MuiDialogActions-root .MuiButton-containedPrimary': {
                    backgroundColor: '#FF4C4C !important',
                  },
                },
              },
            }}
          >
            <QueryClientProvider client={queryClient}>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            </QueryClientProvider>
          </ConfirmProvider>
        </MUIProvider>
      </I18nProvider>
    </TazmeenI18n>,
  );
}
